import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { setActiveSharedViewInRedux } from "../../ViewerRedux/viewerSlice";
import { selectSharedViewState } from "../viewSelectors";
import { basicViewSearchParams, sharedViewFingerprint } from "./sharedViewUrl";

/** A saved link stays immutable. Editing the view returns to an ordinary deep link. */
export function useSharedViewUrl() {
  const [params, setParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const active = useAppSelector(state => state.viewer.activeSharedView);
  const stateId = params.get("state");
  const current = useAppSelector(state => stateId && state.viewer.activeSharedView?.id === stateId
    ? selectSharedViewState(state) : null);
  const previousStateId = useRef(stateId);
  useEffect(() => {
    if (!stateId || !active || stateId !== active.id || !current) return;
    if (sharedViewFingerprint(current) === sharedViewFingerprint(active.state)) return;
    setParams(basicViewSearchParams(current), { replace: true });
    // Keep the marker until navigation completes so the route does not reload the old snapshot.
  }, [stateId, active, current, setParams]);
  useEffect(() => {
    // Creating a link sets the marker just before navigation. Do not clear it in that gap.
    if (previousStateId.current && !stateId && active) dispatch(setActiveSharedViewInRedux(null));
    previousStateId.current = stateId;
  }, [stateId, active, dispatch]);
}
